import { environment } from "../../../environments/environment";

export const print_template = (template, ...args) => {
  const pageContent = template({ base: environment.baseHREF }, ...args);
  const newWindow = window.open(
    "#",
    "_blank",
    "top=0,lef=0,height=600,width=1200"
  );
  newWindow.document.open();
  newWindow.document.write(pageContent);
  newWindow.document.close();
  newWindow.addEventListener("load", () => {
    newWindow.print();
    // newWindow.close();
  });
  return pageContent;
};



// WEBPACK FOOTER //
// ./src/app/shared/helpers/print_helpers.ts